module.exports = __webpack_public_path__ + "fonts/fontello.20881612.eot";